import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PreviewAttachments from 'modules/processes/components/ItemWizard/components/Preview/Attachments'
import PreviewDescription from 'modules/processes/components/ItemWizard/components/Preview/Description'
import PreviewTitle from 'modules/processes/components/ItemWizard/components/Preview/Title'
import EmployeeCF from './EmployeeCF'

const Preview = () => {
  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />

      <Box paddingTop="s16" paddingBottom="s8">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.title')}
        </Text.Normal>

        <Box paddingTop="s8">
          <Text.Normal>
            {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.description')}
          </Text.Normal>
        </Box>
      </Box>

      <EmployeeCF />
    </Box>
  )
}

export default Preview
